module.exports = __webpack_public_path__ + "static/media/img6_1.213a4c80.png";